module.exports = __webpack_public_path__ + "img/icon-staff.6521f768.svg";